export const K_sentences: [string, string][] = [
  ["키케로", "삶이 있는 한 희망은 있다."],
  ["로망로랑", "산다는 것은 치열한 전투이다."],
  ["사무엘존슨", "하루 3시간 걷기, 7년 후 지구 한바퀴."],
  ["파울로 코엘료", "현재에 집중할 수 있다면 행복할 것."],
  ["찰리 채플린", "진정으로 웃으려면 고통을 즐겨라."],
  ["엘버트 허버드", "직업에서 행복을 찾아라."],
  ["켄러", "신은 용기 있는 자를 버리지 않는다."],
  ["헬렌 켈러", "닫힌 문에 멍하지 말고 열린 문을 보라."],
  ["로버트 엘리엇", "피할 수 없으면 즐겨라."],
  ["이드리스 샤흐", "단순하게 살아라."],
  ["엘사 맥스웰", "자신을 비웃어라. 다른 사람보다 먼저."],
  ["채근담", "먼저 핀 꽃은 먼저 진다."],
  ["마르쿠스 아우렐리우스", "행복한 삶을 위해 필요한 것은 거의 없다."],
  ["L.론허바드", "어제를 후회하지 마라. 오늘에 집중하라."],
  ["제임스 오펜하임", "현명한 자는 발치에서 행복을 찾는다."],
  ["랄프 왈도 에머슨", "모든 인생은 실험이다. 많이 실험하라."],
  ["F.스콧 핏제랄드", "실패와 영원한 실패를 혼동하지 마라."],
  ["", "내일은 내일의 태양이 뜬다."],
  ["로버트 엘리엇", "피할 수 없으면 즐겨라."],
  ["L.론허바드", "어제를 후회하지 마라. 오늘에 집중하라."],
  ["터키속담", "계단을 밟아야 계단 위에 올라간다."],
  ["앙드레 말로", "꿈을 그리면 그 꿈을 닮아간다."],
  ["단테", "한 걸음 한 걸음 힘차고 충실하게."],
  ["허버드", "행복은 습관이다. 몸에 지녀라."],
  ["톰 모나건", "성공의 비결은 집중이다."],
  ["찰스다윈", "자신감 있는 표정을 지으면 자신감이 생긴다."],
  ["제임스 딘", "내일 죽을 것처럼 오늘을 살아라."],
  ["간디", "생각이 운명이 된다."],
  ["루이사 메이올콧", "시간의 중요성을 이해하고 활용하라."],
  ["마이크 맥라렌", "목표를 높이 세워라. 포기하지 마라."],
  ["나폴레옹", "1퍼센트의 가능성이 나의 길이다."],
  ["인디언 속담", "자신의 영혼을 탐구하라."],
  ["괴테", "고난이 지나면 기쁨이 온다."],
  ["법정스님", "삶은 순간의 있음이다."],
  ["괴테", "꿈을 간직하면 실현할 때가 온다."],
  ["머더 테레사", "사랑의 정도가 중요하다."],
  ["이소룡", "마음만 있지 말고 실천하라."],
  ["안창호", "기회를 기다리지 말고 실력을 갖춰라."],
  ["맥아더", "늙고 젊은 것은 신념에 달렸다."],
  ["에디슨", "할 수 있는 일을 모두 하라."],
  ["법정스님", "나는 누구인가 스스로 물으라."],
  ["고흐", "하는 일을 사랑하라."],
  ["에밀리 디킨슨", "사랑함으로써 사랑을 배운다."],
  ["글로리아 스타이넘", "꿈을 꾸고 행동하는 사람은 괴짜로 보인다."],
  ["톰 모나건", "실패는 잊고 교훈은 기억하라."],
  ["헤르만 헤세", "일이 즐겁지 않으면 인생은 지옥이다."],
  ["스티브잡스", "훌륭한 아이디어는 단순한 것에서 나온다."],
  ["소크라테스", "행복의 비결은 필요를 줄이는 것이다."],
];

export const E_sentences: [string, string][] = [
  ["Aristotle", "Knowing yourself is the beginning."],
  ["Confucius", "Real knowledge is knowing ignorance."],
  ["Einstein", "Imagination is more important than knowledge."],
  ["Lincoln", "Whatever you are, be a good one."],
  ["Twain", "The secret of getting ahead is starting."],
  ["Disney", "If you can dream it, you can do it."],
  ["Jobs", "Stay hungry, stay foolish."],
  ["Angelou", "You alone are enough."],
  ["Mother Teresa", "Peace begins with a smile."],
  ["Wilde", "Be yourself; everyone else is taken."],
  ["Keller", "Life is a daring adventure or nothing."],
  ["Dalai Lama", "Be kind whenever possible."],
  ["Emerson", "To be yourself is a great accomplishment."],
  ["Roosevelt", "Do one thing every day that scares you."],
  ["Ford", "Whether you think you can, or can’t, you’re right."],
  ["Gandhi", "Be the change you wish to see."],
  ["Da Vinci", "Simplicity is sophistication."],
  ["Plato", "The greatest wealth is to live with little."],
  ["Gretzky", "You miss 100% of the shots you don’t take."],
  ["Lennon", "Life is what happens when busy planning."],
  ["Confucius", "It does not matter how slowly you go."],
  ["Franklin", "Tell me and I forget. Teach and I remember."],
  ["Edison", "Genius is 1% inspiration, 99% perspiration."],
  ["Buddha", "What you think, you become."],
  ["Hawking", "Intelligence is adapting to change."],
  ["Mandela", "It always seems impossible until done."],
  ["Mother Teresa", "Do small things with great love."],
  ["Lao Tzu", "A journey begins with a single step."],
  ["King Jr.", "The time is always right to do right."],
  ["Monroe", "Imperfection is beauty, madness is genius."],
  ["Einstein", "Life is like riding a bicycle. Keep moving."],
  ["Eliot", "It’s never too late to be what you might be."],
  ["Shakespeare", "To thine own self be true."],
  ["Socrates", "An unexamined life is not worth living."],
  ["Rowling", "It does not do to dwell on dreams."],
  ["Jobs", "Your time is limited. Don’t waste it."],
  ["Yoda", "Do, or do not. There is no try."],
  ["Keller", "Worse than being blind is sight without vision."],
  ["Einstein", "Strive to be of value, not success."],
  ["Churchill", "Success is not final, failure is not fatal."],
  ["Roosevelt", "The future belongs to those who dream."],
  ["Lincoln", "It’s the life in your years that counts."],
  ["Confucius", "Our glory is in rising every time we fall."],
];
